import { QueryClient } from '@tanstack/react-query';

export const ReactQueryClient = new QueryClient();
